module.exports = __webpack_public_path__ + "img/ganmao.806b08ff.png";